
/**
 * Adresse du logement
 */
export class AdresseModel {

    codeInsee: string;
}
